/* Parche ResizeObserver antes que cualquier otro módulo (Chart, Swal, etc.) */
import './resizeObserverPatch';

import React from 'react';
import ReactDOM from 'react-dom/client';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

/* Evita salto de ancho en el grid al abrir/cerrar modales (padding extra + zoom en html) */
Swal.mixin({ scrollbarPadding: false });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
